import React from "react";
import TransparentLogoFile from "../assests/images/Latest-Logo.png";
import LogoFile from "../assests/images/logo.svg";
import LogoFile1 from "../assests/icons/qollex-clicrent-logo.png";
import SignUpLogo1 from "../assests/icons/qollex-clicrent-logo.png";

export const TransparentLogo = (props) => {
  return (
    <img
      alt="Logo"
      src={TransparentLogoFile}
      {...props}
      style={{ width: "153%", marginLeft: "-2em" }}
    />
  );
};

export const Logo = (props) => {
  return <img alt="Logo" src={LogoFile} {...props} />;
};

export const Logo1 = (props) => {
  return (
    <img
      alt="Logo"
      src={LogoFile1}
      {...props}
      style={{
        height: "70%",
        width: "70%",
      }}
    />
  );
};

export const SignUpLogo = (props) => {
  return (
    <img
      alt="Logo"
      src={SignUpLogo1}
      {...props}
      style={props.style}
      onClick={() => {
        window.location.href = "https://qollex.com/";
      }}
    />
  );
};
